module.exports = __webpack_public_path__ + "static/media/ren06.487afb0d.png";